function Header({updateModal}) {
    
    return (
        <div className="header">
            <div className="container">
                <img src={process.env.PUBLIC_URL + "/images/iwanttfc-logo-white.svg"} alt="logo" />
                <span onClick={() => updateModal("active")}><img src={process.env.PUBLIC_URL + "/images/icons/icon-close.svg"} alt="close" /></span>
            </div>
            <div className="bg" style={{ backgroundImage: "url(" + process.env.PUBLIC_URL + "/images/header-bg.png)" }}></div>
        </div>

    );
}

export default Header;